// Central game filter definitions used by both pages and seller ad form.
// Each entry can define:
// - normal: true => no platform/account attributes required (price + delivery only)
// - platformOptions: override platform/device list
// - requiresPlatform: explicit boolean to require platform even if normal is true
// - accountAttributes: null for none, or { type, label/options or fields[] }

export const gameFilterConfig = {
  // Normal games (price + delivery only)
  'All Star Tower Defense X': { normal: true },
  'Anime Vanguards': { normal: true },
  'Arc Raiders': { normal: true },
  'Arena Breakout': { normal: true },
  'Arena Breakout: Infinite': { normal: true },
  'Battlenet': { normal: true },
  'Bleach: Brave Souls': { normal: true },
  'Blood Strike': { normal: true },
  'Blox Fruits': { normal: true },
  'Brawl Stars': { normal: true },
  'Car Parking Multiplayer': { normal: true },
  'Chocotto Land': { normal: true },
  'Crunchyroll': { normal: true },
  'Dark and Darker': { normal: true },
  'DarkOrbit': { normal: true },
  'Dead Rails': { normal: true },
  'Delta Force': { normal: true },
  'Diablo 4': { normal: true },
  'Diablo Immortal': { normal: true },
  'Digimon Super Rumble': { normal: true },
  'Discord': { normal: true },
  'DonutSMP': { normal: true },
  'Duet Night Abyss': { normal: true },
  'Elden Ring': { normal: true },
  'Epic Games': { normal: true },
  'Final Fantasy XIV': { normal: true },
  'Fisch': { normal: true },
  'Golden HoYeah': { normal: true },
  'Houchi Shoujo': { normal: true },
  'Identity V': { normal: true },
  'Jujutsu Kaisen Phantom Parade': { normal: true },
  'Knight Online': { normal: true },
  'Knives Out': { normal: true },
  'Last Island of Survival': { normal: true },
  'Last War: Survival': { normal: true },
  '99 Nights in the Forest': { normal: true },

  // Specific filters / attributes
  'Adopt Me': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'multi-select',
      fields: [
        { name: 'age_up_potions', label: 'Age-Up Potions', options: ['0 - 49 Pots', '50 - 99 Pots', '100 - 149 Pots', '150 - 199 Pots', '200 - 249 Pots', '250+ Pots'] },
        { name: 'bucks', label: 'Bucks', options: ['0 - 9.99k Bucks', '10 - 49k Bucks', '50 - 99k Bucks', '100 - 199k Bucks', '200 - 299k Bucks', '300 - 399k Bucks', '400 - 499k Bucks', '500k+ Bucks'] }
      ]
    }
  },
  'EA Sports FC': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'multi-select',
      fields: [
        { name: 'device', label: 'Device', options: ['PC', 'Xbox', 'PlayStation'] },
        { name: 'game_series', label: 'Game Series', options: ['EA FC 24', 'EA FC 25', 'EA FC 26'] }
      ]
    }
  },
  'eFootball': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Game Series',
      options: ['eFootball 2023', 'eFootball 2024', 'eFootball 2025', 'eFootball 2026']
    }
  },
  'Epic Seven': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'multi-select',
      fields: [
        { name: 'device', label: 'Device', options: ['iOS', 'Android'] },
        { name: 'region', label: 'Region', options: ['Global', 'EU', 'Asia', 'Korea'] }
      ]
    }
  },
  'Dragon Ball Legends': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Device',
      options: ['Android', 'Android & iOS', 'iOS']
    }
  },
  'Call of Duty': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'multi-select',
      fields: [
        { name: 'device', label: 'Device', options: ['PlayStation', 'Xbox', 'Steam', 'Battlenet'] },
        { name: 'game_series', label: 'Game', options: ['Modern Warfare II', 'Warzone 4', 'Vanguard', 'Cold War', 'Modern Warfare I', 'Modern Warfare III', 'Black Ops 6', 'Black Ops 7', 'Other'] }
      ]
    }
  },
  'Call of Duty Mobile': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'multi-select',
      fields: [
        { name: 'device', label: 'Device', options: ['Android & iOS', 'Android', 'iOS'] },
        { name: 'game_series', label: 'Game', options: ['CoD Mobile', 'CoD Mobile Warzone', 'Other'] }
      ]
    }
  },
  'DayZ': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Device',
      options: ['PC', 'PlayStation', 'Xbox']
    }
  },
  'Elder Scrolls Online': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'multi-select',
      fields: [
        { name: 'device', label: 'Device', options: ['PC', 'PlayStation', 'Xbox'] },
        { name: 'region', label: 'Region', options: ['EU', 'NA'] }
      ]
    }
  },
  'Fallout 76': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Device',
      options: ['PC', 'PlayStation', 'Xbox']
    }
  },
  'Forza Horizon 5': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Device',
      options: ['PC', 'Xbox', 'PS5']
    }
  },
  'Garena Free Fire': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Region',
      options: ['Thailand', 'Vietnam', 'Malaysia', 'Brazil', 'LATAM', 'MENA', 'India', 'Taiwan', 'Europe', 'Pakistan', 'Bangladesh', 'North America']
    }
  },
  'Genshin Impact': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Region',
      options: ['NA', 'EU', 'Asia', 'SAR']
    }
  },
  'Honkai Impact 3rd': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Region',
      options: ['EU', 'NA', 'CN', 'JP', 'TW/HK/MO', 'KR', 'SEA']
    }
  },
  'Honkai: Star Rail': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Region',
      options: ['Europe', 'America', 'Asia', 'TW/HK/MO']
    }
  },
  'Chaos Zero Nightmare': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Region',
      options: ['Global', 'Asia']
    }
  },
  'Etheria: Restart': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Region',
      options: ['EU', 'NA', 'SEA']
    }
  },
  'ARK: Survival Ascended': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Device',
      options: ['PC', 'PlayStation', 'Xbox']
    }
  },
  'Arknights': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Region',
      options: ['Global', 'Japan', 'China']
    }
  },
  'Battlefield': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Series',
      options: ['Battlefield V', 'Battlefield 2042', 'Battlefield 1', 'Battlefield 3', 'Battlefield 4', 'Battlefield 6']
    }
  },
  'Black Desert Online': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Device',
      options: ['PC', 'PlayStation', 'Xbox']
    }
  },
  'Albion Online': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Server',
      options: ['Albion Americas', 'Albion Asia', 'Albion Europe']
    }
  },
  'Apex Legends': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Device',
      options: ['PC', 'PlayStation', 'Xbox']
    }
  },
  'Girls Frontline 2: Exilium': {
    requiresPlatform: false,
    accountAttributes: {
      type: 'select',
      label: 'Region',
      options: ['Darkwinter Global', 'Haoplay Global', 'Haoplay Korea', 'Haoplay Japan', 'Haoplay Asia', 'Durin']
    }
  },
};

/** Display names from routes / legacy pages → gameFilterConfig keys */
const GAME_FILTER_NAME_ALIASES = {
  'COD Call of Duty': 'Call of Duty',
  'Counter Strike 2': 'Counter-Strike 2',
};

export const getGameFilterConfig = (gameName) => {
  if (!gameName) return null;
  const resolved = GAME_FILTER_NAME_ALIASES[gameName] || gameName;
  if (gameFilterConfig[resolved]) return gameFilterConfig[resolved];
  return gameFilterConfig[gameName] || null;
};
